<script>
import InfoCardPageForm from "@/views/menu/info-card-page/infoCardPageForm";
import Component, { mixins } from "vue-class-component";

@Component({
  inject: {
    infoCardPageService: "infoCardPageService",
    infoBoxService: "infoBoxService",
    toastService: "toastService"
  }
})
export default class InfoCardPageDetail extends mixins(InfoCardPageForm) {
  formId = "detail-info-card-page-form";

  get decoratedElements() {
    return this.allReadonlyFields;
  }

  get fieldColumns() {
    return 2;
  }

  getFormTitle () {
    return this.translations.pageTitles.infoCardPages_detail;
  }

  async afterCreate () {
    this.model = await this.infoCardPageService.read(this.$route.params.id);

    if (this.model.idInfoBox !== null) {
      this.model.infoBoxData = await this.infoBoxService.read(this.model.idInfoBox);
      this.model.infoBoxData.enableInfoBox = this.model.infoBoxData.isEnabled;
    } else {
      this.model.infoBoxData = {
        enableInfoBox: false,
        code: "",
        width: null,
        height: null,
        x: null,
        y: null,
        localizations: [],
      };
    }

    this.isReady = true;
  }
}
</script>
